class ObstetricalResourcesTaceScreening {
    public TaceScreeningDate?: Date;
    public NumberOfDrinksScore?: number;
    public AnnoyedByPeopleScore?: number;
    public CutDownDrinkingScore?: number;
    public MorningDrinkScore?: number;

    constructor(fields?: Partial<ObstetricalResourcesTaceScreening>) {
        Object.assign(this, fields);
    }

    public get TotalScore(): number {
        if (this.NumberOfDrinksScore == null
            && this.AnnoyedByPeopleScore == null
            && this.CutDownDrinkingScore == null
            && this.MorningDrinkScore == null)
            return null;

        return (this.NumberOfDrinksScore ?? 0) + (this.AnnoyedByPeopleScore ?? 0) + (this.CutDownDrinkingScore ?? 0) + (this.MorningDrinkScore ?? 0);
    }
}

export { ObstetricalResourcesTaceScreening };
